<!--  
  -- Accepts search params:
  -- licenseType: 'group' | 'testing'
  -- quantity: number
  -- starts: ISO Date string
  -- months: 6 | 12
  -- state: pricing | quoting
  -->
<script lang="ts" context="module">
  import { literal, union } from 'io-ts';
  import type { TypeOf } from 'io-ts';
  import { DateFromISOString, NumberFromString } from 'io-ts-types';

  const licenseTypeCheck = union([literal('group'), literal('testing')]);

  export const load: Load = async ({ url, session, fetch }) => {
    const params = url.searchParams;

    const type =
      licenseTypeCheck.decode(params.get('licenseType'))._tag === 'Right'
        ? params.get('licenseType')!
        : undefined;
    const quantity =
      NumberFromString.decode(params.get('quantity'))._tag === 'Right'
        ? Number(params.get('quantity'))
        : undefined;
    const starts =
      DateFromISOString.decode(params.get('starts'))._tag === 'Right'
        ? new Date(params.get('starts')!)
        : undefined;
    const months =
      union([literal('6'), literal('12')]).decode(params.get('months'))._tag === 'Right'
        ? Number(params.get('months'))
        : undefined;

    // console.log({
    //   isType: licenseTypeCheck.is(params.get('licenseType')),
    //   isQuantity: NumberFromString.is(params.get('quantity')),
    //   type: params.get('licenseType'),
    //   quantity: params.get('quantity'),
    // });

    return {
      props: {
        licenseDetails: {
          type,
          quantity,
          starts,
          months,
        },
      },
    };
  };

  // export const load = userStorePageLoadFunction;
</script>

<script lang="ts">
  import GetLicenseQuote from '$lib/app/teach/licenses/GetLicenseQuote.svelte';
  import type { Load } from '@sveltejs/kit';
  import LicensePricingTabs from '$lib/teach/LicensePricingTabs.svelte';
  import { onLicensePurchaseRequested } from '$lib/root/LicenseQuotingUtils';
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';
  export let licenseDetails: {
    type?: TypeOf<typeof licenseTypeCheck>;
    quantity?: number;
    months?: 6 | 12;
    starts?: Date;
  };

  let finalDetails: {
    type: 'testing' | 'group';
    quantity: number;
    months: 6 | 12;
    starts: Date;
    expectedSubtotal: number;
  } = {
    type: licenseDetails.type || 'group',
    quantity: licenseDetails.quantity || 10,
    months: licenseDetails.months || 12,
    starts: licenseDetails.starts || new Date(),
    expectedSubtotal: 10000,
  };
  const detailsComplete = licenseDetails.type && licenseDetails.quantity;

  let state: 'pricing' | 'quoting' = detailsComplete ? 'quoting' : 'pricing';
</script>

<PageTitle
  title="uTheory License Quotes"
  description="Get a quote for a uTheory Group or Testing License"
  hideTitle
/>

{#if state === 'pricing'}
  <LicensePricingTabs
    selectedTabClass="h-12"
    unselectedTabClass="h-9"
    bind:licenseType={licenseDetails.type}
    bind:students={licenseDetails.quantity}
    bind:months={licenseDetails.months}
    bind:starts={licenseDetails.starts}
    showActionButtons
    on:quoteRequested={(evt) => {
      finalDetails = {
        ...evt.detail,
      };
      state = 'quoting';
    }}
    on:purchaseRequested={onLicensePurchaseRequested}
  />
{:else if state === 'quoting'}
  <GetLicenseQuote
    licenseType={finalDetails.type}
    quantity={finalDetails.quantity}
    starts={finalDetails.starts}
    months={finalDetails.months}
    on:backToEditDetails={() => {
      state = 'pricing';
    }}
    doneRoute="/teach"
  />
{/if}
